import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const AgriMetaverseDigitalTwin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { seller, product, market } = location.state || {};

  // Guard: if no seller object or prices/messages undefined
  if (!seller) return <p className="text-center mt-20">No seller selected</p>;

  const prices = seller.prices || {};
  const messages = seller.messages || [];

  return (
    <div className="w-full max-w-6xl mx-auto mt-12 p-6">
      <button
        className="mb-6 bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-800"
        onClick={() => navigate(-1)}
      >
        &larr; Back
      </button>

      <div className="relative w-full h-[500px] rounded-2xl shadow-lg overflow-hidden">
        <img
          src={seller.image || ""}
          alt={seller.name || "Seller"}
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col p-6">
          <h2 className="text-3xl text-white font-bold mb-2">{seller.name}</h2>
          <h3 className="text-xl text-white mb-4">{market} - {product}</h3>

          {/* Price List */}
          <div className="bg-white bg-opacity-80 rounded-lg p-4 max-w-sm">
            <h4 className="font-semibold text-green-900 mb-2">Price List</h4>
            <ul className="space-y-2">
              {Object.entries(prices).length > 0 ? (
                Object.entries(prices).map(([prod, price]) => (
                  <li
                    key={prod}
                    className="flex justify-between bg-green-50 p-2 rounded-lg shadow-sm"
                  >
                    <span>{prod}</span>
                    <span className="font-bold text-green-900">{price}</span>
                  </li>
                ))
              ) : (
                <li className="text-gray-700">No price list available</li>
              )}
            </ul>

            {/* Flashing messages */}
            <div className="mt-4 flex flex-col gap-2">
              {messages.length > 0 ? (
                messages.map((msg, idx) => (
                  <motion.div
                    key={idx}
                    className="bg-yellow-400 px-3 py-1 rounded-lg text-sm font-semibold animate-pulse"
                    animate={{ opacity: [0, 1, 0] }}
                    transition={{ repeat: Infinity, duration: 2, delay: idx * 1 }}
                  >
                    {msg}
                  </motion.div>
                ))
              ) : (
                <p className="text-gray-800">No offers or messages</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgriMetaverseDigitalTwin;
